import moment from "moment";
import ReactDatePicker from "react-datepicker"

interface IWeekCalendarProps {
  startDate: Date | null | undefined;
  endDate: Date | null | undefined;
  onChange: (date: [Date | null, Date | null]) => void;
}

export const WeekCalendar = ({ startDate, endDate, onChange}: IWeekCalendarProps) => {
  const _handleSelectWeek = (date: Date | null) => {
    moment.updateLocale('en', {
      week : {
        dow : 1
      }
    });
    var now = moment(date);
    var monday = now.clone().weekday(0).toDate();
    var sunday = now.clone().weekday(6).toDate();
    onChange([monday, sunday]);
  }
  return (
    <ReactDatePicker
      selected={startDate}
      onChange={(date) => _handleSelectWeek(date)}
      calendarStartDay={1}
      startDate={startDate}
      endDate={endDate}
      calendarClassName="!border-0"
      inline
      disabledKeyboardNavigation
      showWeekPicker={true}
    />
  )
}